import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b485b596"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-aspect-ratio-4/3 bg-wild-sand" }
const _hoisted_2 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collage, (variant) => {
      return (_openBlock(), _createElementBlock("div", {
        key: variant.sku,
        class: _normalizeClass(["image", {'image--single-item': _ctx.collage.length === 1}])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (variant.sku === 'logo')
            ? (_openBlock(), _createBlock(_component_c_icon, {
                key: 0,
                name: "icon-bolia-logo",
                class: "w-full text-dusty-grey"
              }))
            : (_openBlock(), _createBlock(_component_ProductImage, {
                key: 1,
                sku: variant.sku,
                "bg-color": "#f5f5f5",
                "aspect-ratio": 5/3,
                "cache-bust": variant.imageVersion,
                "width-on-screen": _ctx.widthOnScreen
              }, null, 8, ["sku", "cache-bust", "width-on-screen"]))
        ])
      ], 2))
    }), 128))
  ]))
}